import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import type { SortState } from '../../hooks/useTableSort';

interface Props {
    label: string;
    sortKey: string;
    sort: SortState;
    onSort: (key: string) => void;
    /** Tailwind classes for the <th> (e.g. "text-right" for numeric columns). */
    className?: string;
}

/**
 * A clickable, sortable table header cell. Shows an up/down chevron for the
 * active sort column and a faint hover hint otherwise. Pair with useTableSort.
 */
export function SortableTh({ label, sortKey, sort, onSort, className = '' }: Props) {
    const active = sort.key === sortKey;
    return (
        <th
            className={`px-3 py-2 ${className}`}
            aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
        >
            <button
                type="button"
                onClick={() => onSort(sortKey)}
                className="group inline-flex items-center gap-1 hover:text-slate-700"
            >
                <span>{label}</span>
                {active
                    ? (sort.dir === 'asc' ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />)
                    : <ChevronsUpDown className="h-3.5 w-3.5 opacity-0 transition group-hover:opacity-40" />}
            </button>
        </th>
    );
}
